/**
 * useAuthSnapshot — read-only auth state for @shared consumers.
 *
 * The frontend-side AuthProvider (in `frontend/src/providers/AuthProvider.tsx`)
 * lives outside the `@shared` source tree, so components in `@shared` cannot
 * import its `useAuth` hook. This hook subscribes to `apiClient.onAuthChange`
 * directly, giving any `@shared` component a reactive view of the access token.
 */
import { useEffect, useState } from "react";

import { apiClient } from "@shared/lib/api/client";

export interface AuthSnapshot {
  accessToken: string | null;
  isAuthenticated: boolean;
}

export function useAuthSnapshot(): AuthSnapshot {
  const [accessToken, setAccessToken] = useState<string | null>(() =>
    apiClient.getAccessToken(),
  );

  useEffect(() => {
    return apiClient.onAuthChange(({ accessToken: next }) => {
      setAccessToken(next);
    });
  }, []);

  return { accessToken, isAuthenticated: !!accessToken };
}
